import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { RouterEffects } from './router.effects';
import {
  ROUTE_BLOG_ID,
  ROUTE_CLIENT_ID,
  ROUTE_CONTEXT,
  ROUTE_DATA,
  ROUTE_ELEVATOR_FRAGMENT,
  ROUTE_HOME_NODE_ID,
  ROUTE_IS_HOME,
  ROUTE_IS_SETTINGS,
  ROUTE_LANGUAGE,
  ROUTE_NEWS_ID,
  ROUTE_PAGE_ID,
  ROUTE_PROJECT_ID,
  ROUTE_SERVICE_ID,
  ROUTE_SOLUTION_ID,
  ROUTED_ID,
  ROUTER_URL,
} from './icilalune-router.tokens';
import { select, Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import {
  selectFragment,
  selectIsHome,
  selectIsSettings,
  selectRouteBlogId,
  selectRouteClientId,
  selectRouteContext,
  selectRouteHomeNodeId,
  selectRouteLanguage,
  selectRouteNestedData,
  selectRouteNewsId,
  selectRoutePageId,
  selectRouteProjectId,
  selectRouteServiceId,
  selectRouteSolutionId,
  selectRouteUrl,
} from './icilalune-router.selectors';
import { combineLatest, distinctUntilChanged, map, Observable } from 'rxjs';
import { isEqual } from '@madeinlune/ngx-operators';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([RouterEffects])],
  providers: [
    {
      provide: ROUTER_URL,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteUrl));
      },
    },
    {
      provide: ROUTE_NEWS_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteNewsId));
      },
    },
    {
      provide: ROUTE_BLOG_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteBlogId));
      },
    },
    {
      provide: ROUTE_IS_HOME,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectIsHome));
      },
    },
    {
      provide: ROUTE_IS_SETTINGS,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectIsSettings));
      },
    },
    {
      provide: ROUTE_HOME_NODE_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteHomeNodeId));
      },
    },
    {
      provide: ROUTE_CLIENT_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteClientId));
      },
    },
    {
      provide: ROUTE_SERVICE_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteServiceId));
      },
    },
    {
      provide: ROUTE_PAGE_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRoutePageId));
      },
    },
    {
      provide: ROUTE_PROJECT_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteProjectId));
      },
    },
    {
      provide: ROUTE_SOLUTION_ID,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteSolutionId));
      },
    },
    {
      provide: ROUTE_CONTEXT,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteContext));
      },
    },
    {
      provide: ROUTE_ELEVATOR_FRAGMENT,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectFragment));
      },
    },
    {
      provide: ROUTE_LANGUAGE,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteLanguage));
      },
    },
    {
      provide: ROUTE_DATA,
      deps: [Store],
      useFactory: (store: Store<RouterReducerState>) => {
        return store.pipe(select(selectRouteNestedData));
      },
    },
    {
      provide: ROUTED_ID,
      deps: [
        ROUTE_PROJECT_ID,
        ROUTE_SERVICE_ID,
        ROUTE_SOLUTION_ID,
        ROUTE_BLOG_ID,
        ROUTE_HOME_NODE_ID,
        ROUTE_NEWS_ID,
        ROUTE_PAGE_ID,
        ROUTE_CLIENT_ID,
        ROUTE_ELEVATOR_FRAGMENT,
      ],
      useFactory: (
        projectId$: Observable<string>,
        serviceId$: Observable<string>,
        solutionId$: Observable<string>,
        blogId$: Observable<string>,
        homeId$: Observable<string>,
        newsId$: Observable<string>,
        pageId$: Observable<string>,
        client$: Observable<string>,
        elevatorFragment$: Observable<string>
      ) => {
        return combineLatest([
          projectId$,
          serviceId$,
          solutionId$,
          blogId$,
          homeId$,
          newsId$,
          pageId$,
          client$,
          elevatorFragment$,
        ]).pipe(
          isEqual(),
          map((result) => {
            return result.filter((id) => !!id).shift();
          }),
          distinctUntilChanged()
        );
      },
    },
  ],
})
export class IcilaluneRouterModule {}
